@if (showLabels) {
<div class="range-labels">
  <span data-test-id="range-select-labels-min">{{ minLabel() }}</span>
  <span data-test-id="range-select-labels-max">{{ maxLabel() }}</span>
</div>
}
<div class="range-select-container">
  <div class="range-select-sliders" [style.background]="sliderBackground()">
    <input
      [id]="startSliderId()"
      [class]="startCSSClass()"
      type="range"
      [value]="startValue()"
      [min]="minValue()"
      [max]="maxValue()"
      [step]="stepValue()"
      (input)="startInput($event)"
      (change)="startChange($event)"
      [style.z-index]="startZIndex()"
      [disabled]="disabled"
      data-test-id="range-select-start-slider"
    />
    <input
      [id]="endSliderId()"
      [class]="endCSSClass()"
      type="range"
      [value]="endValue()"
      [min]="minValue()"
      [max]="maxValue()"
      [step]="stepValue()"
      (input)="endInput($event)"
      (change)="endChange($event)"
      [style.z-index]="endZIndex()"
      [disabled]="disabled"
      data-test-id="range-select-end-slider"
    />
  </div>
</div>
@if (showLabels) {
<div class="selected-labels">
  <span data-test-id="range-select-selected-labels-start">{{
    startLabel()
  }}</span>
  <span data-test-id="range-select-selected-labels-end">{{ endLabel() }}</span>
</div>
}
